import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '..'

export interface IDownload {
  id: string
  title: string
  extension: string
  file: string
  fileGuid: string
  image: string
  fileUrl: string
  requiresUserInformation: string
  fileName: string
}

@Module({ namespaced: true })
export default class RequestDownloadModule extends VuexModule {
  isOpen = false

  download: IDownload | null = null
  form = []

  @Mutation
  open(item: any): void {
    this.isOpen = true
    this.download = item.download
    this.form = item.form

    // use the content overlay onclick function
    store.commit('openContentOverlay', () => {
      store.commit('requestDownload/close')
    })
  }

  @Mutation
  close(): void {
    this.isOpen = false
    this.download = null
    this.form = []
    store.commit('closeContentOverlay', false)
  }
}
